// let lenis = null;

// function createLenis() {
//   return new Lenis({
//     duration: 1.4,
//     easing: (t) => 1 - Math.pow(1 - t, 4),
//     mouseMultiplier: 1,
//     smooth: true,
//     direction: "vertical",
//   });
// }

// function enableLenis() {
//   if (!lenis) {
//     lenis = createLenis();
//   }
// }

// function disableLenis() {
//   if (lenis) {
//     lenis.destroy();
//     lenis = null;
//   }
// }

// function raf(time) {
//   const expertise = document.querySelector('.our-expertise');
//   const showroom = document.querySelector('.live-showroom__iframe');
//   const htmlHasOverflow = document.documentElement.classList.contains('overflow');
//   const pageTest = document.querySelector('body').classList.contains('page-template-page-tests');
//   const inGsapSection = expertise ? expertise.classList.contains('active') : false;
//   const isMobile = window.innerWidth <= 1024;

//   if (!isMobile && !htmlHasOverflow && !inGsapSection && !pageTest && !showroom) {
//     enableLenis();
//     lenis.raf(time);
//   } else {
//     disableLenis();
//   }

//   requestAnimationFrame(raf);
// }


// function waitForLenis() {
//   if (window.Lenis) {
//     requestAnimationFrame(raf);
//   } else {
//     setTimeout(waitForLenis, 100);
//   }
// }

// waitForLenis();